export default "__VITE_ASSET__Cjrn7Pib__"